
import Vue from 'vue'
import Component from 'vue-class-component'
import { namespace } from 'vuex-class'
import { getModule } from 'vuex-module-decorators'

const dnote = namespace('dnote')
import { Note } from '@/lib/dnote'
import DNoteModule from '@/store/modules/dnote'
import MarkdownPreview from '@/components/MarkdownPreview.vue'

const Props = Vue.extend({
  props: {
  }
})

@Component({
  name: 'note-preview-dialog',
  components: {
    MarkdownPreview,
  },
})
export default class NotePreviewDialog extends Props {
  get currentNote(): Note | null {
    const module = getModule(DNoteModule, this.$store);
    return module.currentNote
  }

  get showNotePreviewDialog(): boolean {
    const module = getModule(DNoteModule, this.$store);
    return module.showNotePreviewDialog
  }

  set showNotePreviewDialog(show: boolean) {
    const module = getModule(DNoteModule, this.$store);
    module.setShowNotePreviewDialog(show)
  }

  /* eslint-disable no-unused-vars */
  @dnote.Mutation
  setShowNotePreviewDialog!: (show: boolean) => void
  /* eslint-enable no-unused-vars */
}
